/** 근로자 public API base (proxy → 백엔드) */
export const API_BASE_URL = "/api";
